import React, { useState } from 'react';
import { Checkbox } from '@carbon/react';
import styles from './structure-grid-item.module.scss';
import classNames from 'classnames';

interface StructureGridItemProps {
  name: string;
  source: string;
  geologicInterval: string;
  color: string;
  checked: boolean;
  onChange: (
    _evt: React.ChangeEvent<HTMLInputElement>,
    data: { checked: boolean }
  ) => void;
  disabled?: boolean;
  uniqueId: string;
  intersect?: boolean;
}

const StructureGridItem: React.FC<StructureGridItemProps> = ({
  name,
  source,
  geologicInterval,
  color,
  checked,
  onChange,
  disabled = false,
  uniqueId,
  intersect = true,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Grid is disabled if either disabled prop is true or intersect is false
  const isDisabled = disabled || !intersect;
  return (
    <div
      className={classNames(styles.structureGridItemContainer, {
        [styles.structureGridItemContainerNoIntersect]: !intersect,
      })}
      onMouseEnter={() => !intersect && setShowTooltip(true)}
      onMouseLeave={() => !intersect && setShowTooltip(false)}
    >
      {intersect && (
        <span
          className={styles.structureGridColorSwatch}
          style={{ backgroundColor: color }}
        />
      )}
      <div className={styles.structureGridItemContent}>
        <div
          className={classNames(styles.structureGridItemName, {
            [styles.structureGridItemNameDisabled]: !intersect,
          })}
        >
          <strong>{geologicInterval}</strong>
        </div>
        <div
          className={classNames(styles.structureGridItemSource, {
            [styles.structureGridItemSourceDisabled]: !intersect,
          })}
        >
          {name} - Source: {source}
        </div>
      </div>
      <Checkbox
        id={uniqueId}
        checked={checked}
        onChange={(
          _evt: React.ChangeEvent<HTMLInputElement>,
          { checked }: { checked: boolean }
        ) => onChange(_evt, { checked })}
        labelText=""
        className={styles.structureGridItemCheckbox}
        disabled={isDisabled}
        data-testid={`checkbox-${uniqueId}`}
      />
      {!intersect && showTooltip && (
        <div className={styles.structureGridItemTooltip}>
          <div className={styles.structureGridItemTooltipText}>
            This grid is not available over the viewable extent
          </div>
        </div>
      )}
    </div>
  );
};

export default StructureGridItem;
